import { RadioGroup } from 'components/RadioGroup'
import Styles from './MediaTypeField.module.scss'
import { useField } from 'formik'
import { RadioCard } from './RadioCard'
import { MediaType } from 'components/Wizards/schemas/shared/mediaType'

const MediaTypeField = () => {
  const [field, , helpers] = useField('media_type')

  return (
    <RadioGroup
      value={field.value}
      onChange={helpers.setValue}
      aria-label="What kind of content would you like?"
      className={Styles.mediaTypeField}
    >
      <RadioCard
        value={MediaType.Document}
        label="Text Only Posts"
        icon={
          <img
            src="https://res.cloudinary.com/almanac/image/upload/v1729851429/blaze_assets/media_type_field/text_only_posts_fngyer.png"
            alt=""
          />
        }
      />
      <RadioCard
        value={MediaType.DocumentWithImages}
        label="Posts with Stock Images"
        icon={
          <img
            src="https://res.cloudinary.com/almanac/image/upload/v1729851429/blaze_assets/media_type_field/posts_with_stock_images_zesmrx.png"
            alt=""
          />
        }
      />
      <RadioCard
        value={MediaType.Design}
        label="Posts with Custom Designs"
        icon={
          <img
            src="https://res.cloudinary.com/almanac/image/upload/v1732612403/blaze_assets/media_type_field/posts_with_custom_designs_bejcun.png"
            alt=""
          />
        }
      />
    </RadioGroup>
  )
}

export { MediaTypeField }
